const PlotSubCategoryColors = {
  AccidentReport: "#EF9A9A",
  Buoy: "#80CBC4",
  Construction: "#FFE082",
  DangerZone: "#BA68C8",
  FishingGear: "#80DEEA",
  FishingNet: "#4DD0E1",
  FloatingMatter: "#A5D6A7",
  GasStation: "#FFCC80",
  LeisureSpot: "#81D4FA",
  LimitedNavigationArea: "#B39DDB",
  Marina: "#E6EE9C",
  PatrolBoat: "#64B5F6",
  Problem: "#B0BEC5",
  Shallows: "#CE93D8",
  UnderConstruction: "#C5E1A5",
  UnderRescue: "#FFF59D",
  WaveAttention: "#FFB74D"
};

const VesselCategoryColors = {
  App: "#50B0A0",
  Bike: "#FBED56",
  Cargo: "#F3A841",
  Company: "#EF83AB",
  Fishing: "#2C71B6",
  MapModeOther: "#C4B28C",
  Passenger: "#F0EFEF",
  Tanker: "#EE604C",
  Tug: "#8DC658",
  Work: "#A561D6",
  Sailboat: "#FF7AAB",
  Barge: "#A8A7A7",
};

const getPlotSubCategoryColor = subCategoryId => {
  switch (subCategoryId) {
    default:
      return "#FFFFFF";
    case "1": // 工事区域
      return PlotSubCategoryColors.Construction;
    case "2": // 航行制限区域
      return PlotSubCategoryColors.LimitedNavigationArea;
    case "3": // マリーナ
      return PlotSubCategoryColors.Marina;
    case "4": // 給油所
      return PlotSubCategoryColors.GasStation;
    case "5": // レジャースポット
      return PlotSubCategoryColors.LeisureSpot;

    case "6": // 危険区域
      return PlotSubCategoryColors.DangerZone;
    case "7": // 波浪注意
      return PlotSubCategoryColors.WaveAttention;
    case "8": // 浅瀬
      return PlotSubCategoryColors.Shallows;
    case "9": // 浮遊物
      return PlotSubCategoryColors.FloatingMatter;
    case "10": // ブイ
      return PlotSubCategoryColors.Buoy;
    case "11": // 取締船
      return PlotSubCategoryColors.PatrolBoat;
    case "12": // 網
      return PlotSubCategoryColors.FishingNet;
    case "13": // 地図の問題
      return PlotSubCategoryColors.Problem;
    case "14": // 工事中
      return PlotSubCategoryColors.UnderConstruction;
    case "15": // 救助中
      return PlotSubCategoryColors.UnderRescue;
    case "16": // 事故
      return PlotSubCategoryColors.AccidentReport;
    case "17": // 漁具設置区域
      return PlotSubCategoryColors.FishingGear;
  }
};

const getVesselCategoryColor = categoryId => {
  switch (categoryId) {
    case 1: // タンカー船
    case "1": // タンカー船
      return VesselCategoryColors.Tanker;
    case 2: // 貨物船
    case "2": // 貨物船
      return VesselCategoryColors.Cargo;
    case 3: // タグボート
    case "3": // タグボート
      return VesselCategoryColors.Tug;
    case 4: // 旅客船
    case "4": // 旅客船
      return VesselCategoryColors.Passenger;
    case 5: // 漁船
    case "5": // 漁船
      return VesselCategoryColors.Fishing;
    case 6: // 自社船
    case "6": // 自社船
      return VesselCategoryColors.Company;
    case 7: // プレジャーボート
    case "7": // プレジャーボート
      return VesselCategoryColors.App;
    case 8: // 水上バイク
    case "8": // 水上バイク
      return VesselCategoryColors.Bike;
    default:
    case 9: // その他
    case "9": // その他
      return VesselCategoryColors.MapModeOther;
    case 10: // 作業船
    case "10": // 作業船
      return VesselCategoryColors.Work;
    case 11: // ヨット
    case "11": // ヨット
      return VesselCategoryColors.Sailboat;
    case 12: // バージ
    case "12": // バージ
      return VesselCategoryColors.Barge;
    }
};

export default {
  getPlotSubCategoryColor,
  getVesselCategoryColor
};
